module.exports = __webpack_public_path__ + "img/7_97.3c2e7bca.png";